import { render } from "./notification-panel.vue?vue&type=template&id=f4fafa4a"
import script from "./notification-panel.vue?vue&type=script&lang=js"
export * from "./notification-panel.vue?vue&type=script&lang=js"

import "./notification-panel.vue?vue&type=style&index=0&id=f4fafa4a&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__